import { createSelector } from 'reselect';
import find from 'ramda/es/find';
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';


const selectNumberInCart = createSelector(
  [
    state => state.shop.cart.cartItems,
    (_, { productId }) => productId,
  ],
  (cartItems, id) => pipe(
    find(({ variantId }) => (variantId === id)),
    prop('quantity'),
  )(cartItems),
);

export default selectNumberInCart;
